import Select, {components} from "react-select";

import React, {useRef, useState} from 'react';

const MultiSelect = (props) => {
    const [selectInput, setSelectInput] = useState("");
    const hasRequiredBackground = props.classNameWrapper?.includes("bg-[#fdfdee]");
    const isAllSelected = useRef(false);
    const selectAllLabel = useRef("Selecionar todos");
    const allOption = {value: "*", label: selectAllLabel.current};

    const comparator = (v1, v2) => v1.label.localeCompare(v2.label);
    const filterOptions = (options, input) => {
        return options?.filter(({ label }) => {
            if (props.cpfFilter) {
                const cleanLabel = String(label).replace(/\D/g, "");
                const cleanInput = String(input).replace(/\D/g, "");
                return cleanLabel.startsWith(cleanInput);
            }
            return label?.toLowerCase()?.includes(input?.toLowerCase());
        }).sort(comparator);
    };

    let filteredOptions = filterOptions(props.options, selectInput);
    let filteredSelectedOptions = filterOptions(props.value, selectInput);

    const customStyles = {
        control: (base, {isDisabled}) => {
            return {
                ...base,
                height: "32px",
                minHeight: "32px",
                borderWidth: props.invalid ? "2px" : "1px",
                borderColor: props.invalid ? "#dc2626" : "#e5e7eb",
                boxShadow: props.invalid ? "none" : base.boxShadow,
                transition: "border-color 150ms ease-out, border-width 150ms ease-out, box-shadow 150ms ease-out",
                backgroundColor: isDisabled ? "#e9ecef" : hasRequiredBackground ? "#fdfdee" : base.backgroundColor,
                cursor: "pointer"
            };
        },
        valueContainer: (base) => ({
            ...base,
            maxHeight: "65px",
            overflow: "auto",
            fontSize: "14px"
        }),
        option: (styles, {isSelected, isFocused}) => {
            return {
                ...styles,
                backgroundColor:
                    isSelected && !isFocused
                        ? null
                        : isFocused && !isSelected
                            ? styles.backgroundColor
                            : isFocused && isSelected
                                ? "#DEEBFF"
                                : null,
                color: isSelected ? null : null,
                fontSize: "14px"
            };
        },
        menuPortal: (def) => ({...def, zIndex: props.menuPortalZIndex ?? 2000}),
        indicatorsContainer: (def) => ({...def, top: "-3px", position: "relative"}),
    };

    isAllSelected.current = filteredOptions.length > 0 && filteredSelectedOptions.length === filteredOptions.length;

    if (filteredSelectedOptions?.length > 0) {
        if (filteredSelectedOptions?.length === filteredOptions?.length)
            selectAllLabel.current = `${filteredOptions.length} opções selecionadas`;
        else
            selectAllLabel.current = `${filteredSelectedOptions?.length} / ${filteredOptions.length} selecionados`;
    } else selectAllLabel.current = "Selecionar todos";

    allOption.label = selectAllLabel.current;

    const Option = (props) => (
        <components.Option {...props}>
            {
                props.value === "*" && !isAllSelected.current && filteredSelectedOptions?.length > 0 ? (
                    <input
                        key={props.value}
                        type="checkbox"
                        ref={(input) => {
                            if (input) input.indeterminate = true;
                        }}
                        style={{
                            verticalAlign: props.selectProps.wrapValues ? "top" : "middle",
                            marginTop: props.selectProps.wrapValues ? "2.5px" : "0",
                        }}
                    />
                ) : (
                    <input
                        key={props.value}
                        type="checkbox"
                        checked={props.isSelected || isAllSelected.current}
                        onChange={() => {}}
                        style={{
                            verticalAlign: props.selectProps.wrapValues ? "top" : "middle",
                            marginTop: props.selectProps.wrapValues ? "2.5px" : "0",
                        }}
                    />
                )
            }

            <label
                style={{
                    marginLeft: "5px",
                    transform: props.selectProps.wrapValues ? "none" : "translate(0, 2px)",
                    maxWidth: "calc(100% - 30px)",
                    whiteSpace: props.selectProps.wrapValues ? "normal" : "nowrap",
                    wordBreak: props.selectProps.wrapValues ? "break-word" : "break-all",
                    overflow: "hidden",
                    textOverflow: props.selectProps.wrapValues ? "unset" : "ellipsis",
                    lineHeight: "18px",
                    display: "inline-block",
                    verticalAlign: props.selectProps.wrapValues ? "top" : "middle",
                }}
                title={props.label}
            >
                {props.label}
            </label>
        </components.Option>
    );

    const MultiValue = ({ selectProps, data }) => {
        const index = selectProps.value.findIndex(selected => selected.value === data.value);
        const isLastSelected = index === selectProps.value.length - 1;

        const multiStyle = {
            WebkitLineClamp: 1,
            WebkitBoxOrient: 'vertical',
            wordBreak: 'break-all',
            overflow: 'hidden',
            OTextOverflow: 'ellipsis',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '90%',
            position: "relative",
            top: "-3px"
        };

        if (isLastSelected && !selectProps.inputValue) {
            if (selectProps.value.length >= 6) {
                return (
                    <div style={multiStyle}>
                        {selectProps.value.length} opções selecionadas
                    </div>
                );
            }

            return (
                <div style={multiStyle}>
                    {selectProps.value.map(e => e.label).join(", ")}
                </div>
            );
        }
        return null;
    };

    const customFilterOption = ({value, label}, input) =>
        (value !== "*" && label.toLowerCase().includes(input.toLowerCase())) ||
        (value === "*" && filteredOptions?.length > 0);

    const onInputChange = (inputValue, event) => {
        if (event.action === "input-change") {
            props.setActiveLabel(true);
            setSelectInput(inputValue);
        }
        else if (event.action === "menu-close" && selectInput !== "")
            setSelectInput("");
    };

    const onKeyDown = (e) => {
        const inputValue = props?.inputValue ?? selectInput;

        if (e.key === "Enter" && !inputValue) {
            e.preventDefault();
        }

        if (e.key === " " || e.key === "Enter") {
            e.stopPropagation();
        }
    };

    const handleChange = (selected) => {
        const isCpfFilter = !!props.cpfFilter;

        const matchesFilter = (selectInput, optionLabel) => {
            if (isCpfFilter) {
                const cleanLabel = String(optionLabel).replace(/\D/g, "");
                const cleanInput = String(selectInput).replace(/\D/g, "");
                return cleanLabel.startsWith(cleanInput);
            }
            return optionLabel.toLowerCase().includes(selectInput?.toLowerCase());
        };

        if (
            selected.length > 0 &&
            !isAllSelected.current &&
            (selected[selected.length - 1].value === allOption.value ||
                JSON.stringify(filteredOptions) ===
                JSON.stringify(selected.sort(comparator)))
        )
            return props.onChange(
                [
                    ...(props.value ?? []),
                    ...props.options.filter(
                        ({label}) =>
                            matchesFilter(selectInput, label) &&
                            (props.value ?? []).filter((opt) => opt.label === label)
                                .length === 0
                    ),
                ].sort(comparator)
            );
        else if (
            selected.length > 0 &&
            selected[selected.length - 1].value !== allOption.value &&
            JSON.stringify(selected.sort(comparator)) !==
            JSON.stringify(filteredOptions)
        )
            return props.onChange(selected);
        else
            return props.onChange([
                ...(props.value ?? []).filter(
                    ({label}) =>
                        !label.toLowerCase().includes(selectInput?.toLowerCase())
                ),
            ]);
    };

    return (
        <Select
            {...props}
            inputValue={props?.inputValue ?? selectInput}
            onInputChange={props?.onInputChange ?? onInputChange}
            onKeyDown={onKeyDown}
            options={props.showSelectAll === false ? props.options : [allOption, ...props.options]}
            onChange={handleChange}
            components={{
                Option,
                MultiValue,
                ...props.components,
            }}
            filterOption={props.filterOption ?? customFilterOption}
            menuPlacement={props.menuPlacement ?? "auto"}
            styles={customStyles}
            isMulti
            wrapValues={props.wrapValues}
            closeMenuOnSelect={false}
            tabSelectsValue={false}
            backspaceRemovesValue={false}
            hideSelectedOptions={false}
            blurInputOnSelect={false}
            ref={props.selectRef}
        />
    );
};


export default MultiSelect;